import * as React from "react";

import { TagLabel } from "./styles";

export default ({tag}) => {
    return <TagLabel tag={tag}>{tag.title}</TagLabel>
}